export default __webpack_public_path__ + "static/media/August_01.451be1f5.png";